import { useEffect, useState } from "react";
import { api, apiError } from "../lib/api";
import { CampaignCard } from "../components/CampaignCard";
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { toast } from "sonner";
import { Search } from "lucide-react";

const GENRES = ["all", "Fantasy", "Thriller", "Romance", "Sci-Fi", "Non-Fiction", "Mystery", "Historical", "Young Adult", "Horror", "Literary Fiction"];
const FORMATS = [
  { v: "all", label: "All formats" },
  { v: "ebook", label: "Ebook" },
  { v: "physical", label: "Physical" },
  { v: "both", label: "Ebook + Physical" },
];

export default function BrowseCampaigns() {
  const [items, setItems] = useState([]);
  const [genre, setGenre] = useState("all");
  const [fmt, setFmt] = useState("all");
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/campaigns", { params: { genre, arc_format: fmt, search: q || undefined } })
      .then(({ data }) => setItems(data))
      .catch((e) => toast.error(apiError(e)))
      .finally(() => setLoading(false));
  }, [genre, fmt, q]);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
      <div className="overline mb-2">Open ARC Campaigns</div>
      <h1 className="font-serif text-3xl sm:text-4xl tracking-tight mb-8">Find your next read</h1>

      <div className="paper-card p-4 mb-8 flex flex-col md:flex-row gap-3">
        <div className="relative flex-1">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input placeholder="Search titles…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" data-testid="browse-search-input" />
        </div>
        <Select value={genre} onValueChange={setGenre}>
          <SelectTrigger className="md:w-52" data-testid="browse-genre-select"><SelectValue placeholder="Genre" /></SelectTrigger>
          <SelectContent>{GENRES.map((g) => <SelectItem key={g} value={g}>{g === "all" ? "All genres" : g}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={fmt} onValueChange={setFmt}>
          <SelectTrigger className="md:w-52" data-testid="browse-format-select"><SelectValue placeholder="Format" /></SelectTrigger>
          <SelectContent>{FORMATS.map((f) => <SelectItem key={f.v} value={f.v}>{f.label}</SelectItem>)}</SelectContent>
        </Select>
      </div>

      {loading ? (
        <div className="text-slate-500" data-testid="browse-loading">Loading…</div>
      ) : items.length === 0 ? (
        <div className="paper-card p-10 text-center text-slate-600" data-testid="browse-empty">
          <div className="font-serif text-2xl mb-2">No campaigns match yet.</div>
          <p className="text-sm">Try clearing filters or check back soon — authors post new ARCs every week.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="browse-grid">
          {items.map((c) => <CampaignCard key={c.id} campaign={c} />)}
        </div>
      )}
    </div>
  );
}
